/**
 * True only for payments that actually went through the Stripe gateway.
 *
 * `payment_type === 'online'` alone is NOT a gateway signal: it means
 * "customer-initiated through the app", and until 2026-08-19 the customer
 * slip-upload flow also created `online` payments (method `transfer`) —
 * keying the Stripe badge on payment_type mislabeled unverified bank slips
 * as gateway-confirmed on four production invoices. Stripe payments are only
 * ever created with method credit_card or promptpay, so gateway = online AND
 * one of those methods. Legacy online+transfer rows fall through to the
 * slip-verification rendering, which is what they really are.
 */
const GATEWAY_METHODS = ['credit_card', 'promptpay']

export function isGatewayPayment(payment: { payment_type?: string; payment_method: string }): boolean {
  return payment.payment_type === 'online' && GATEWAY_METHODS.includes(payment.payment_method)
}
